import * as Sentry from "@sentry/react";
import Feedback from "../apiResources/Feedback";
import {
  SHOW_REVIEW_PAGE,
  CLOSE_REVIEW_PAGE,
  LOAD_EMPLOYER_PENDING_REVIEWS,
  LOAD_EMPLOYER_PENDING_REVIEWS_ERROR,
  SUBMIT_REVIEW,
  SET_FORM_LOADING,
  SHOW_FORM_THANK_YOU,
  HIDE_FORM_THANK_YOU,
  SUBMIT_REVIEW_ERROR,
  TOGGLE_REVIEW_MODAL,
} from "./types";

export const loadEmployerPendingReviews = () => async (dispatch) => {
  try {
    const feedbacks = await Feedback.where({ status: "pending" })
      .includes(["job", "recruiter", "recruiter_user"])
      .order({ id: "desc" })
      .all();

    dispatch({
      type: LOAD_EMPLOYER_PENDING_REVIEWS,
      payload: feedbacks.data,
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_EMPLOYER_PENDING_REVIEWS_ERROR,
      payload: error,
    });
  }
};

export const toggleReviewModal = (pendingReview) => (dispatch) => {
  dispatch({
    type: TOGGLE_REVIEW_MODAL,
    payload: pendingReview,
  });
};

export const showReviewPage = (pendingReview) => (dispatch) => {
  // in case the recruiterUser has been deleted
  const agentName = pendingReview.recruiterUser
    ? pendingReview.recruiterUser.fullName
    : null;
  const review = {
    agentName,
    agentCompany: pendingReview.recruiter.name,
    jobTitle: pendingReview.job.title,
    jobId: pendingReview.job.id,
    reviewId: pendingReview.id,
  };

  dispatch({
    type: SHOW_REVIEW_PAGE,
    payload: review,
  });
};

export const closeReviewPage = () => (dispatch) => {
  dispatch({
    type: CLOSE_REVIEW_PAGE,
  });
};

export const toggleThankYou = () => (dispatch) => {
  dispatch({
    type: SHOW_FORM_THANK_YOU,
  });

  setTimeout(() => {
    dispatch({
      type: HIDE_FORM_THANK_YOU,
    });
  }, 3000);
};

export const submitReview = (e, data) => async (dispatch) => {
  e.preventDefault();
  dispatch({ type: SET_FORM_LOADING });

  let feedback = await Feedback.find(data.reviewId);
  feedback = feedback.data;

  feedback.communication = data.step1Rating;
  feedback.qualityOfSubmission = data.step2Rating;
  feedback.speedOfResponse = data.step3Rating;
  feedback.professionalism = data.step4Rating;
  feedback.message = data.reviewMessage;
  feedback.status = "published";
  feedback.jobId = data.jobId;

  try {
    const success = await feedback.save();
    if (success) {
      dispatch({ type: SUBMIT_REVIEW, payload: feedback.id });
      dispatch(toggleThankYou());
    } else {
      dispatch({
        type: SUBMIT_REVIEW_ERROR,
        payload: feedback.errors,
      });
    }
  } catch (err) {
    Sentry.captureException(error);

    dispatch({
      type: SUBMIT_REVIEW_ERROR,
      payload: { message: { fullMessage: "Woops internal server error" } },
    });
  }
};
